import axios from 'axios'
import makeDebug from 'debug'
import qs from 'qs'
import wcs from '.'

const debug = makeDebug('cart:clickAndCollect')

export class WcsCertifiedReseller {
  static fetchIsCertifiedReseller = async (domain: string) => {
    const endpoint = wcs.getEndPoint('certifiedReseller')
    const stringifiedParams = qs.stringify({ terms: domain })
    const url = `${endpoint}?${stringifiedParams}`

    try {
      const response = await axios.get(url)
      return response.data
    } catch (e) {
      debug(e)
      if (e instanceof Error) {
        return {
          error: true,
        }
      }
    }
  }
}
